//This util exists to circumvent tree shaking
const checkNodeEnvVariable = (expectedValue = 'production'): boolean => {
  return process.env.NODE_ENV === expectedValue;
};

export default checkNodeEnvVariable;
